export default "__VITE_PUBLIC_ASSET__3a38d7aa__"